import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledVideoInfo = styled.div`
  position: relative;
  padding-left: 19px;
`

const StyledVideoDuration = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        white,
        blicktvGrey: { btvGrey_100 },
      },
    },
  }) => css`
    background-color: ${btvGrey_100};
    color: ${white};
    font-size: 14px;
    line-height: 19px;
    padding: 0 3px;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    font-family: ${sourceSansPro};
  `}
`

const VideoInfo: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => (
  <StyledVideoInfo>
    <StyledVideoDuration>{children}</StyledVideoDuration>
  </StyledVideoInfo>
)

export default VideoInfo
